import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

/**
 * Top-level group for all asset-related features.
 * Granting this group gives access to all asset sub-features at any depth.
 *
 * @example
 * // Grant all assets access
 * allow: [ASSETS_FEATURE_GROUP.guid]
 *
 * // Grant all assets except typography
 * allow: [ASSETS_FEATURE_GROUP.guid], deny: [ASSETS_TYPOGRAPHY_FEATURE_GROUP.guid]
 */
export const ASSETS_FEATURE_GROUP: FeatureGroup = {
  guid: 'c4f8d3b2-7e1a-4c9f-b825-6a3e7d0f1c2b',
  name: 'assets',
  description: 'Organization assets — colors, images, typography, and description',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
